import React from 'react';
import logo_d from './img/friday-logo-d.png';

import './Header.scss';

const Header: React.FC = () => {

    return (
        <div className='header'>
            <img src={logo_d} className='app-logo' alt='' />
        </div>
    );
};

export default Header;